import { TextField, Typography } from "@mui/material";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

import HNSColors from "../../../../../ui library/HNSColors";
import { STYLES } from "../../utils/customStyles";

export default function TimeField({ label, value, onChangeVal, placeholder = "hh:mm aa" }) {
  const toDate = (value) => (value ? new Date(`1970-01-01T${value}`) : null);
  return (
    <div className="flex w-full flex-col gap-1">
      <Typography className="text-[14px] font-semibold" style={{ color: HNSColors.neutrals[500] }}>
        {label}
      </Typography>
      <TimePicker
        value={toDate(value)}
        onChange={onChangeVal}
        renderInput={(params) => <TextField {...params} size="small" />}
        className="w-full"
        slotProps={{
          textField: {
            sx: {
              ...STYLES.dateTimePicker.textField,
              "& input": { textTransform: "lowercase" },
            },
            placeholder,
          },
          openPickerButton: {
            disableRipple: true,
            sx: {
              ...STYLES.dateTimePicker.openPickerButton,
              color: HNSColors.primary[500],
            },
          },
        }}
      />
    </div>
  );
}
